import React from "react";
import BlockContent from "../blockContent";
import Image from "gatsby-plugin-sanity-image"

export default function SideBySideSegment({ segment }) {
  return (
    <div className="segment sideBySideSegment" style={{ background: segment.segstyle?.bg.value }}>
      <div className="container">
        <div className="d-flex align-items-center flex-wrap text-center text-md-left">
          {segment.alignment === "left" &&
            <div className="col-sm-12 col-md-6 text-center">
              {segment.image && <Image {...segment.image} width={600} alt={segment.title} className="mt-3 mb-3" />}
            </div>}
          <div className="col-md-6">
            {segment.title && <h2>{segment.title}</h2>}
            {segment.description && <BlockContent blocks={segment.description} />}
            {segment.button.url && <a href={segment.button.url} className="btn btn-opaque" style={{ marginTop: "15px" }}>{segment.button.text}</a>}
          </div>
          {segment.alignment === "right" &&
            <div className="col-md-6 text-center">
              {segment.image && <Image {...segment.image} width={900} quality={100} alt={segment.title} className="mt-3 mb-3" />}
            </div>}
        </div>
      </div>
    </div>
  )
}